// components/EmailPhoneToggle.js
import React from 'react';

export default function EmailPhoneToggle({ mode, onToggle }) {
  const isPhone = mode === 'phone';
  return (
    <label
      htmlFor="emailPhoneToggle"
      className="relative inline-flex cursor-pointer select-none items-center justify-center rounded-xl bg-black/20 backdrop-blur-2xl border border-white/10 p-1"
      style={{boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.1), 0 4px 20px rgba(0,0,0,0.2)'}}
    >
      <input
        type="checkbox"
        name="emailPhoneToggle"
        id="emailPhoneToggle"
        className="sr-only"
        checked={isPhone}
        onChange={onToggle}
      />
      <span
        className={`flex items-center space-x-2 rounded-lg py-2 px-4 text-sm font-medium transition-all duration-200 ${
          !isPhone ? 'bg-white/10 backdrop-blur text-white' : 'text-white/60 hover:text-white/80'
        }`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-5 h-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M16.5 12a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 1 0-2.636 6.364M16.5 12V8.25"
          />
        </svg>
        <span>Email</span>
      </span>
      <span
        className={`flex items-center space-x-2 rounded-lg py-2 px-4 text-sm font-medium transition-all duration-200 ${
          isPhone ? 'bg-white/10 backdrop-blur text-white' : 'text-white/60 hover:text-white/80'
        }`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-5 h-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3"
          />
        </svg>
        <span>Phone</span>
      </span>
    </label>
  );
}